<template>
  <div class="header">
    <div class="header_box">
      <div class="logo">
        <router-link to="/"> <img src="../assets/imgs/logo_n.png" alt=""> </router-link>
      </div>
      <ul class="nav">
        <li :class="['nav_item', !PageName ? 'current' : '' ]"> <router-link class="nav_t" to="/"> 首页 </router-link> </li>
        <li :class="['nav_item', PageName ? 'current' : '' ]">
          <span class="nav_t"> 更多 </span>
          <ul class="submenu">
            <li :class=" PageName == 'aboutUs' ? 'current' : '' "><router-link to="/aboutUs"> 关于我们 </router-link></li>
            <li :class=" PageName == 'joinUs' ? 'current' : '' "><router-link to="/joinUs"> 加入我们 </router-link></li>
            <li :class=" PageName == 'contactUs' ? 'current' : '' "><router-link to="/contactUs"> 联系我们 </router-link></li>
          </ul>
        </li>
      </ul>
      <div class="wxCode">
        <div class="wx_btn">
          <img src="../assets/imgs/wx.svg" alt="">
          <span>EA生意小助手</span>
        </div>
        <div class="wx_ewm">
          <img src="../assets/imgs/eaCode.jpg" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    PageName:{
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  methods: {

  },
  created() {

  }
}
</script>

<style lang="scss" scoped>
  .header {
    width: 100%;
    box-shadow: 0 0 20px 0 #ccc;
  }

  .header_box {
    margin: 0 auto;
    width: 1200px;
    height: 80px;
    display: flex;
    align-items: center;
  }

  .logo {
    flex: 1;

    img {
      margin: 15px 0;
      width: 191px;
      height: 50px;
    }
  }

  .nav {
    margin: 0 0 0 auto;
    display: flex;



    .nav_item {
      position: relative;
      margin-left: 20px;
      width: 80px;
      height: 80px;
      line-height: 80px;
      text-align: center;
      font-size: 16px;

      &::after {
        content: '';
        position: absolute;
        bottom: 15px;
        left: 50%;
        transform: translateX(-50%);
        width: 0;
        height: 5px;
        border-radius: 3px;
        background: #409EFF;
        transition: all .2s ease 0s;
      }

      &.current,
      &:hover {
        .nav_t {
          font-size: 18px;
          font-weight: 600;
          color: #409EFF;
          cursor: pointer;
        }

        &::after {
          width: 30px;
        }
      }

      &:hover {
        .submenu {
          display: block;
        }
      }
    }

    &:hover .current::after {
      width: 0;
    }

    .current:hover::after {
      width: 30px;
    }

    .submenu {
      display: none;
      position: absolute;
      top: 80px;
      left: -20px;
      padding: 5px 15px 20px;
      background: #fff;
      border-radius: 5px;
      box-shadow: 0 0 20px 0 #A0CFFF;

      &::after {
        content: '';
        position: absolute;
        top: -24px;
        left: 48px;
        border: 12px solid transparent;
        border-bottom: 12px solid #fff;
      }

      li {
        width: 90px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        border-bottom: 1px solid #e4e4e4;
        font-size: 16px;
        color: #666;

        &:hover,
        &.current {
          color: #409EFF;
          cursor: pointer;
        }
      }
    }
  }

  .wxCode {
    position: relative;
    margin-left: 120px;
    padding: 20px 0;

    &:hover {
      cursor: pointer;

      .wx_ewm {
        display: block;
      }
    }

    .wx_ewm {
      display: none;
      position: absolute;
      top: 80px;
      right: 0;
      padding: 5px;
      background: #fff;
      border-radius: 10px;
      box-shadow: 0 0 20px 0 #A0CFFF;

      img {
        display: block;
        width: 150px;
        height: 150px;
      }

      &::after {
        content: '';
        position: absolute;
        top: -36px;
        left: 60px;
        border: 20px solid transparent;
        border-bottom: 16px solid #fff;
      }
    }
  }

  .wx_btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 160px;
    height: 40px;
    background: -webkit-linear-gradient(0deg, rgba(64, 158, 255, 1) 0%, rgba(189, 217, 249, 1) 100%);
    background: -moz-linear-gradient(90deg, rgba(64, 158, 255, 1) 0%, rgba(189, 217, 249, 1) 100%);
    background: linear-gradient(90deg, rgba(64, 158, 255, 1) 0%, rgba(189, 217, 249, 1) 100%);
    border-radius: 20px;
    font-size: 14px;
    color: #fff;

    img {
      margin-right: 5px;
      width: 24px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/header.vue